export enum JacquardMachineLoomLayoutZoneType {
  SELVEDGE,
  DESIGN
}
